import Text7 from './Text7'
export default Text7
